(function () {
  'use strict';

  function initializeUpsell(root) {
    if (root.getAttribute('data-upsell-initialized') === 'true') return;
    root.setAttribute('data-upsell-initialized', 'true');

    var configElement = root.querySelector('[data-upsell-config]');
    if (!configElement) return;

    var config;
    var currentVariantId;
    var adding = true;
    var selectedVariants = {};
    var cartRevision = 0;

    try {
      config = JSON.parse(configElement.textContent);
    } catch (error) {
      console.error('[Complete Your Set] Invalid configuration.', error);
      return;
    }

    currentVariantId = String(config.initialVariantId);
    var configuredUpsellIds = new Set(Object.values(config.variants).flat().map(function (item) {
      return String(item.id);
    }));

    function getItems() {
      return config.variants[currentVariantId] || [];
    }

    function selectionKey(parentVariantId, addonVariantId) {
      return String(parentVariantId) + ':' + String(addonVariantId);
    }

    function setStatus(message) {
      var status = root.querySelector('[data-upsell-status]');
      if (status) status.textContent = message;
    }

    function syncCart(cart) {
      selectedVariants = {};
      cart.items.forEach(function (item) {
        var properties = item.properties || {};
        var isCustomAddon = String(properties._upsell_parent_product) === String(config.parentProductId)
          && Boolean(properties._upsell_parent_variant)
          && properties._upsell_source === 'complete_your_set';
        var isOcuAddon = configuredUpsellIds.has(String(item.variant_id))
          && Boolean(properties._ocu_offer_id || properties._ocu_offer_reference_id);
        if (isCustomAddon) {
          selectedVariants[selectionKey(properties._upsell_parent_variant, item.variant_id)] = true;
        } else if (isOcuAddon) {
          selectedVariants[selectionKey(currentVariantId, item.variant_id)] = true;
        }
      });
      render();
    }

    document.addEventListener('cart:updated', function (event) {
      if (!event.detail || !event.detail.cart) return;
      cartRevision += 1;
      syncCart(event.detail.cart);
    });

    window.addEventListener('ocu:cart:updated', function () {
      var revision = ++cartRevision;
      fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { cache: 'no-store' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to refresh your add-on selections.');
          return response.json();
        })
        .then(function (cart) {
          if (revision === cartRevision) syncCart(cart);
        })
        .catch(function (error) { console.warn('[Complete Your Set]', error); });
    });

    async function addItem(item, slot, card, button, imageWrap) {
      var selected = Boolean(selectedVariants[selectionKey(currentVariantId, item.id)]);
      if ((!item.available && !selected) || adding) return;
      adding = true;
      button.textContent = selected ? 'Removing…' : 'Adding…';
      root.setAttribute('aria-busy', 'true');
      root.querySelectorAll('button').forEach(function (control) { control.disabled = true; });
      setStatus('');
      try {
        var productInfo = root.closest('product-info');
        var form = (productInfo || document).querySelector('.main-product-form');
        if (!form || typeof form.addUpsellToCart !== 'function') {
          throw new Error('Unable to add this product. Please reload the page and try again.');
        }
        await form.addUpsellToCart(item.id, selected, getItems().map(function (upsell) {
          return String(upsell.id);
        }), currentVariantId);
      } catch (error) {
        setStatus(error.message || 'Unable to update this product in your cart.');
      } finally {
        adding = false;
        root.removeAttribute('aria-busy');
        render();
      }
    }

    function render() {
      var grid = root.querySelector('[data-upsell-grid]');
      var items = getItems();

      if (!grid) return;

      while (grid.firstChild) {
        grid.removeChild(grid.firstChild);
      }

      root.hidden = items.length === 0;

      for (var index = 0; index < items.length; index += 1) {
        (function (item, slot) {
          var card = document.createElement('article');
          var imageWrap = document.createElement('div');
          var title = document.createElement('h3');
          var price = document.createElement('p');
          var button = document.createElement('button');
          var selected = Boolean(selectedVariants[selectionKey(currentVariantId, item.id)]);
          card.className = 'complete-your-set__card' + (selected ? ' is-selected' : '');

          card.setAttribute('data-variant-id', String(item.id));
          card.setAttribute('data-upsell-slot', String(slot));

          imageWrap.className = 'complete-your-set__image-wrap';

          if (item.available || selected) {
            imageWrap.setAttribute('role', 'button');
            imageWrap.setAttribute('tabindex', '0');
            imageWrap.setAttribute('aria-pressed', String(selected));
            imageWrap.setAttribute(
              'aria-label',
              (selected ? 'Remove ' : 'Add ') + item.productTitle + (selected ? ' from cart' : ' to cart')
            );
          }

          if (item.image) {
            var image = document.createElement('img');

            image.className = 'complete-your-set__image';
            image.src = item.image;
            image.alt = item.productTitle;
            image.width = 700;
            image.height = 700;
            image.loading = slot === 0 ? 'eager' : 'lazy';

            imageWrap.appendChild(image);
          }

          title.className = 'complete-your-set__title';
          title.textContent = item.productTitle;

          price.className = 'complete-your-set__price';
          price.appendChild(document.createTextNode(item.price));

          if (item.compareAtPrice) {
            var comparePrice = document.createElement('span');

            comparePrice.className = 'complete-your-set__compare-price';
            comparePrice.textContent = item.compareAtPrice;

            price.appendChild(comparePrice);
          }

          button.type = 'button';
          button.className = 'complete-your-set__button';
          button.textContent = selected ? 'Selected ✓' : item.available ? 'Add' : 'Sold out';
          button.setAttribute('aria-pressed', String(selected));

          button.disabled = (!item.available && !selected) || adding;

          button.addEventListener('click', function () {
            addItem(item, slot, card, button, imageWrap);
          });

          if (item.available || selected) {
            imageWrap.addEventListener('click', function () {
              addItem(item, slot, card, button, imageWrap);
            });

            imageWrap.addEventListener('keydown', function (event) {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                addItem(item, slot, card, button, imageWrap);
              }
            });
          }

          card.appendChild(imageWrap);
          card.appendChild(title);
          card.appendChild(price);
          card.appendChild(button);

          grid.appendChild(card);
        })(items[index], index);
      }
    }

    function changeVariant(variantId) {
      if (!variantId) return;

      currentVariantId = String(variantId);
      render();

    }

    render();

    var initialRevision = cartRevision;
    fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load your cart. Please reload the page.');
        return response.json();
      })
      .then(function (cart) {
        if (cartRevision === initialRevision) syncCart(cart);
      })
      .catch(function (error) { setStatus(error.message); })
      .finally(function () {
        adding = false;
        render();
      });

    if (typeof subscribe === 'function') {
      subscribe('variant-change', function (event) {
        if (!event || !event.data || !event.data.variant) return;
        changeVariant(event.data.variant.id);
      });
    }

    var productInfo = root.closest
      ? root.closest('product-info')
      : null;

    var variantInput = productInfo
      ? productInfo.querySelector(
        '.main-product-form input[name="id"]'
      )
      : null;

    if (variantInput) {
      variantInput.addEventListener('change', function (event) {
        changeVariant(event.target.value);
      });
    }
  }

  function initializeAll() {
    var blocks = document.querySelectorAll('complete-your-set');

    for (var index = 0; index < blocks.length; index += 1) {
      initializeUpsell(blocks[index]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:block:select', initializeAll);
})();
